import React from "react";
import { HeartIcon, LaughIcon, ThumbsUpIcon } from "lucide-react";
import type { ReactionType } from "../../types/facebook";
const styles: Record<ReactionType, {
  bg: string;
  Icon: typeof ThumbsUpIcon;
}> = {
  like: {
    bg: "bg-fb-blue",
    Icon: ThumbsUpIcon
  },
  love: {
    bg: "bg-[#F33E58]",
    Icon: HeartIcon
  },
  haha: {
    bg: "bg-[#F7B125]",
    Icon: LaughIcon
  }
};
export function ReactionIcons({
  types,
  size = "md"
}: {
  types: ReactionType[];
  size?: "sm" | "md";
}) {
  const dim = size === "sm" ? "h-[18px] w-[18px]" : "h-5 w-5";
  const icon = size === "sm" ? "h-2.5 w-2.5" : "h-3 w-3";
  return <span className="flex -space-x-1" data-id="element-61" data-mp="11s7sdla9t4zr">
      {types.map(t => {
      const {
        bg,
        Icon
      } = styles[t];
      return <span key={t} className={`flex ${dim} items-center justify-center rounded-full ${bg} ring-2 ring-white`} data-id="element-62" data-mp="wuz5x8i3aesp">
            <Icon className={`${icon} fill-white text-white`} data-id="element-63" data-mp="rtryjajuzhmk" />
          </span>;
    })}
    </span>;
}